// Shared with app/(publicScreens)/producer/[slug]/layout.tsx,
// app/(publicScreens)/market/[slug]/layout.tsx (meta description + JSON-LD),
// and GeneralProfile.tsx (visible page body fallback when a listing has no
// description of its own — keeps thin/empty profiles from shipping near-zero
// real text to visitors and crawlers).

export function truncate(str: string, max = 155): string {
  if (str.length <= max) return str
  return str.slice(0, str.lastIndexOf(' ', max)) + '…'
}

export function buildProducerDescription(listing: any): string {
  const location = listing.city
    ? `${listing.city}${listing.state ? `, ${listing.state}` : ''}`
    : null

  if (listing.tagLine) {
    return truncate(`${listing.tagLine}${location ? ` Based in ${location}.` : ''}`)
  }

  if (listing.description) return truncate(listing.description)

  const base = `${listing.name}${location ? ` in ${location}` : ''} — a local farm or food producer on Culineer.`

  const practiceNames = (listing.Practices || [])
    .slice(0, 2)
    .map((p: any) => p.tag)
    .filter(Boolean)

  const productNames = (listing.ingredients || [])
    .map((i: any) => i.name)
    .filter(Boolean)

  const qualifier = practiceNames.length ? ` — ${practiceNames.join(', ')}` : ''
  let description = base
  for (const name of productNames) {
    const candidate = description.length === base.length
      ? `${description} Specializing in ${name}${qualifier}.`
      : description.replace('.', `, ${name}.`)
    if (candidate.length > 155) break
    description = candidate
  }

  return description
}

export function buildMarketDescription(listing: any): string {
  const location = listing.city
    ? `${listing.city}${listing.state ? `, ${listing.state}` : ''}`
    : null

  if (listing.tagLine) {
    return truncate(`${listing.tagLine}${location ? ` Located in ${location}.` : ''}`)
  }

  if (listing.description) return truncate(listing.description)

  const base = `${listing.name}${location ? ` in ${location}` : ''} — a local farmers market on Culineer.`

  const practiceNames = (listing.Practices || [])
    .slice(0, 2)
    .map((p: any) => p.tag)
    .filter(Boolean)

  const productNames = (listing.ingredients || [])
    .map((i: any) => i.name)
    .filter(Boolean)

  const qualifier = practiceNames.length ? ` (${practiceNames.join(', ')})` : ''
  let description = base
  for (const name of productNames) {
    const candidate = description.length === base.length
      ? `${description} Find ${name}${qualifier} and more.`
      : description.replace(' and more.', `, ${name} and more.`)
    if (candidate.length > 155) break
    description = candidate
  }

  return description
}
